/** @jsx jsx */
import { __assign, __extends, __rest } from "tslib";
import { Component } from 'react';
import { jsx } from '@emotion/core';
import ArrowLeft from '@atlaskit/icon/glyph/arrow-left';
import { B50, N0, N30A } from '@atlaskit/theme/colors';
import { gridSize, layers } from '@atlaskit/theme/constants';
import { Slide } from '../transitions';
import { createExtender } from '../utils';
import ContentOverrides from './content';
import SidebarOverrides from './sidebar';
// Misc.
// ------------------------------
var widths = {
    full: '100vw',
    extended: '95vw',
    narrow: 45 * gridSize(),
    medium: 60 * gridSize(),
    wide: 75 * gridSize(),
};
// Wrapper
// ------------------------------
var Wrapper = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 'narrow' : _b, shouldUnmountOnExit = _a.shouldUnmountOnExit, props = __rest(_a, ["width", "shouldUnmountOnExit"]);
    return (jsx("div", __assign({ css: {
            backgroundColor: N0,
            display: 'flex',
            height: '100vh',
            left: 0,
            overflow: 'hidden',
            position: 'fixed',
            top: 0,
            width: widths[width],
            zIndex: layers.blanket() + 1,
        } }, props)));
};
var IconWrapper = function (props) { return (jsx("button", __assign({ type: "button", css: {
        alignItems: 'center',
        background: 0,
        border: 0,
        borderRadius: '50%',
        color: 'inherit',
        cursor: props.onClick ? 'pointer' : undefined,
        display: 'flex',
        fontSize: 'inherit',
        height: 5 * gridSize(),
        justifyContent: 'center',
        lineHeight: 1,
        marginBottom: 2 * gridSize(),
        padding: 0,
        width: 5 * gridSize(),
        '&:hover': {
            backgroundColor: props.onClick ? N30A : undefined,
        },
        '&:active': {
            backgroundColor: props.onClick ? B50 : undefined,
            outline: 0,
        },
    } }, props))); };
var defaults = {
    Sidebar: SidebarOverrides,
    Content: ContentOverrides,
};
var DrawerPrimitive = /** @class */ (function (_super) {
    __extends(DrawerPrimitive, _super);
    function DrawerPrimitive() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DrawerPrimitive.prototype.render = function () {
        var _a = this.props, children = _a.children, Icon = _a.icon, onClose = _a.onClose, onCloseComplete = _a.onCloseComplete, onOpenComplete = _a.onOpenComplete, overrides = _a.overrides, props = __rest(_a, ["children", "icon", "onClose", "onCloseComplete", "onOpenComplete", "overrides"]);
        var getOverrides = createExtender(defaults, overrides);
        var _b = getOverrides('Sidebar'), Sidebar = _b.component, sideBarOverrides = __rest(_b, ["component"]);
        var _c = getOverrides('Content'), Content = _c.component, contentOverrides = __rest(_c, ["component"]);
        return (jsx(Slide, __assign({ component: Wrapper, onExited: onCloseComplete, onEntered: onOpenComplete }, props),
            jsx(Sidebar, __assign({}, sideBarOverrides),
                jsx(IconWrapper, { onClick: onClose, "data-test-selector": "DrawerPrimitiveSidebarCloseButton" }, Icon ? jsx(Icon, { size: "large" }) : jsx(ArrowLeft, { label: "Close drawer" }))),
            jsx(Content, __assign({}, contentOverrides), children)));
    };
    return DrawerPrimitive;
}(Component));
export default DrawerPrimitive;
//# sourceMappingURL=index.js.map